import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from "react-router-dom";
import '../css/Profile.css'
import {
  Avatar as MuiAvatar,
} from "@mui/material";
import { FaRegCopy } from "react-icons/fa6";
import Avatar, { genConfig } from "react-nice-avatar";
import axios from 'axios';
import NoData from '../components/NoData'
import getDate from '../../../utils/getDate';
import { updateAlert } from '../redux/actions';
import { connect } from 'react-redux';


function Profile(props) {
  const [searchParams] = useSearchParams();
  const uid = searchParams.getAll("uid")[0];
  const [user, setUser] = useState({})
  const navigate = useNavigate();

  useEffect(() => {
    axios({
      method: 'get',
      url: `/api/m2d/userinfo/profile/${uid}`
    }).then((res) => {
      setUser(res.data);
    }).catch((err) => {
      console.log(err);
    })
  }, [setUser, uid]);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(user?.email);
    props.handleAlert("success", "Successfully copied!");
  }

  return (
    <>
      <div className="page-content">
        <div className="profile-layout">
          <div className="profile-userinfo">
            <div className="avatar">
              {user.avatar ? (
                <Avatar
                  style={{
                    height: "90px",
                    width: "90px",
                    marginBottom: "-40px",
                    transform: "translateY(-60px)",
                  }}
                  {...genConfig(JSON.parse(user.avatar))}
                />
              ) : (
                <MuiAvatar
                  sx={{
                    height: 90,
                    mb: "-40px",
                    width: 90,
                    transform: "translateY(-60px)",
                  }}
                />
              )}
            </div>

            <div className="name">
              {user?.firstName} {user?.lastName}
            </div>
            <div className="username">
              <div className="content">
                {user?.email || "No email"}
              </div>
              <FaRegCopy onClick={handleCopyEmail} style={{
                fontSize: '14px',
                height: '21px',
                marginLeft: '5px',
                cursor: 'pointer'
              }} />
            </div>
            <div className="role">
              {user?.featureUsers?.find(fu => fu.featureId === 2)?.role}
            </div>
          </div>
          <div className="profile-info">
            <div className="title">{user?.firstName}'s Project{user?.m2dProjects?.length > 1 ? "s" : ""}</div>
            <div className="projects">
              {user?.m2dProjects?.map((proj, index) => {
                return (
                  <div className="project" key={index} onClick={() => navigate(`/m2d/projects/${proj.id}`)}>
                    {proj.title}
                  </div>
                )
              })}
              {user?.m2dProjects?.length === 0 ? (
                <div className="nodata">
                  <NoData info="No Projects" style={{
                    height: '130px',
                    backgroundColor: 'white',
                    margin: 0
                  }} />
                </div>

              ) : null}
            </div>
            <div className="title">{user?.firstName}'s Model{user?.m2dModels?.length > 1 ? "s" : ""}</div>
            <div className="models">
              {user?.m2dModels?.map((model, index) => {
                return (
                  <div className="model" key={index} onClick={() => navigate(`/m2d/models/${model.id}`)}>
                    <div className="model-name">
                      {model.name}
                    </div>
                    <div className="model-create-time">
                      {getDate(model.createdAt)}
                    </div>
                  </div>
                )
              })}
              {user?.m2dModels?.length === 0 ? (
                <div className="nodata">
                  <NoData info="No Models" style={{
                    height: '130px',
                    backgroundColor: 'white',
                    margin: 0
                  }} />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.main.user,
    role: state.m2d.role
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);